import React, { useEffect, useState } from 'react';
import { CircularProgress, Backdrop } from '@mui/material';

export default function LoadingViewAria(props) {
    const { loading } = props;


    return (
        <Backdrop open={loading} style={{ zIndex: 999999, color: "#fff", position: "absolute" }}>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}